export default {
		name: 'transportOrder',
		data() {
			return {
				shop: [],
				getData: {},
				clear: {},
				ShopID: 0,
				orders: [],
				pageIndex: 1,
				pageRows: 10,
				count: 0,
				Transporter: this.$store.state.Transporter.filter(x => x.ShopID == this.$store.state.user.ShopID || x
					.UserID == 0),
				searchText:''
			};
		},
		created() {

			this.shop = this.$store.state.shop.filter(x => x.areaID == this.$store.state.user.areaID && x.ShopType <= 1);
			
			this.ShopID = this.$store.state.user.ShopID;
			this.userType = [{
				id: 0,
				text: '管理员'
			}, {
				id: 1,
				text: '店长'
			}, {
				id: 2,
				text: '店员'
			}, {
				id: 3,
				text: '派送员'
			}];
			this.getData = function() {
				this.$request.request({
					url: 'weChatOrder/getWeChatOrderByOrderState',
					data: {
						state: 2,
						areaID: this.$store.state.user.areaID,
						pageCount: this.pageRows,
						pageIndex: this.pageIndex,
						searchText:this.searchText
					},
					method: 'post'
				}).then(res => {
					if (res.result) {
						this.orders = res.orders;
						this.count = res.count;

					}
				});
			}

			this.getData();

		},
		methods: {
			setOrder(CustomerOrderID) {
				this.$router.replace('/weChat/transportOrder/transportOrderDetail/' + CustomerOrderID)
			},
			customerOrderSend(i) {
				this.$request.request({
					url: 'weChatOrder/transportComplete',
					data: {
						TransporterID: i.TransporterID,
						OperatorID: this.$store.state.user.UserID,
						ShopID: this.$store.state.user.ShopID,
						OrderID: i.CustomerOrderID
					},
					method: 'post'
				}).then(res => {
					if (res.result)
						this.getData();
					else
						this.$uil.showMessage({
							text: res.message
						});

				});
			},
			changePages(s) {
				if (s == 'up') {
					if (this.pageIndex == 1)
						return;
					else
						this.pageIndex--;

				} else {
					if (this.pageIndex * this.pageRows >= this.count)
						return;
					else
						this.pageIndex++;
				}

				this.getData();
			},
			changePageRows() {
				if (this.pageIndex * this.pageRows >= this.count)
					this.pageIndex = 1;
				this.getData();
			}
		},
		computed: {
			up() {
				if (this.pageIndex == 1)
					return true;
				else
					return false;
			},
			down() {
				if (this.pageIndex * this.pageRows >= this.count)
					return true;
				else
					return false;
			},
			page() {
				if (Math.ceil((this.count / this.pageRows)) == 0)
					return this.pageIndex + '/' + 1 + '页';
				else
					return this.pageIndex + '/' + Math.ceil((this.count / this.pageRows)) + '页';
			}
			

		},
		filters: {
			UserType(v) {
				if (v == '0') return '管理员';
				if (v == '1') return '店长';
				if (v == '2') return '店员';
				if (v == '3') return '派送员';
			}
		},
		activated() {
			this.getData();
		}

	}